import React, { Component } from "react";
import "./SwitchButtonWithLabels.scss";
import SwitchButton from "../SwitchButton/SwitchButton";

class SwitchButtonWithLabels extends Component {
  render() {
    const { isChecked, leftLabel, rightLabel, handleChange,...props } = this.props;
    return (
      <div className="switch-button-with-labels" {...props}>
        <p className="switch-button-with-labels__label">{leftLabel}</p>
        <SwitchButton isChecked={isChecked} handleChange={handleChange} />
        <p className="switch-button-with-labels__label">{rightLabel}</p>
      </div>
    );
  }
}

export default SwitchButtonWithLabels;
